import { render, staticRenderFns } from "./LotteryKindSetting.vue?vue&type=template&id=1b4fdb13&"
import script from "./LotteryKindSetting.vue?vue&type=script&lang=js&"
export * from "./LotteryKindSetting.vue?vue&type=script&lang=js&"
import style0 from "./LotteryKindSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports